import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-50895f84"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "usersBatchSetLossGames"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "color": "#f56c6c"
  }
};
const _hoisted_3 = {
  key: 1,
  style: {
    "color": "#f56c6c"
  }
};
const _hoisted_4 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("分类：");

const _hoisted_6 = {
  style: {
    "margin": "10px 0"
  }
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("彩票：");

const _hoisted_8 = {
  class: "fast-set-row"
};
const _hoisted_9 = {
  class: "fast-set-item"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("快速设置");

const _hoisted_11 = {
  class: "sub"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("确认修改");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");

  const _component_el_radio_button = _resolveComponent("el-radio-button");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.users.length ? (_openBlock(), _createElementBlock("span", _hoisted_2, "当前设置用户：" + _toDisplayString($data.users.toString()), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_3, "当前设置用户：" + _toDisplayString($data.users.username), 1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.active_pid,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.active_pid = $event),
    size: "small",
    onChange: $options.change_group
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_group, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.name,
        label: item.pid
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_link, {
    underline: false
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  }), _createVNode(_component_el_radio_group, {
    modelValue: $data.active_gid,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.active_gid = $event),
    size: "small",
    onChange: $options.change_game
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.game_list, item => {
      return _openBlock(), _createBlock(_component_el_radio_button, {
        key: item.id,
        label: item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.gname), 1)]),
        _: 2
      }, 1032, ["label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])]), _createVNode(_component_el_table, {
    data: $data.loss_data,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    append: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      size: "small",
      icon: "el-icon-check",
      class: "fast-btn",
      onClick: $options.fast_set_col
    }, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fast, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "fast-set-item",
        key: key
      }, [_createVNode(_component_el_input, {
        modelValue: $data.fast[key],
        "onUpdate:modelValue": $event => $data.fast[key] = $event,
        size: "small",
        placeholder: "快速设置",
        class: "fast-input"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]);
    }), 128))])]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "下注类型",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "lower",
      label: "自动降赔率额度",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.lower,
        "onUpdate:modelValue": $event => scope.row.lower = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "rate",
      label: "每次降赔率",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.rate,
        "onUpdate:modelValue": $event => scope.row.rate = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    size: "small",
    type: "info",
    plain: "",
    onClick: $options.cancel
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub_change_loss
  }, {
    default: _withCtx(() => [_hoisted_13]),
    _: 1
  }, 8, ["onClick"])])]);
}